import {Badge} from 'antd';

import {FormattedDateTime} from '../../../provider/locale/formatted-date-time';
import {Locale} from '../../../provider/locale/locale';
import {useLocale} from '../../../provider/locale/locale-hook';
import {PromotionDetailType} from '../../../service/promotions/promotions-type';
import {
    PublicationPreviewInfo,
    PublicationPreviewRowType,
} from '../../publication-preview/info/publication-preview-info';
import {Text} from '../../text/text';
import {getPromotionStatusConfig} from '../promotions-helper';

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
};

type PropsType = {
    promotion: PromotionDetailType;
    onClose: VoidFunction;
};

export function PromotionInfo({promotion, onClose}: PropsType): JSX.Element {
    const {getLocalizedString} = useLocale();

    const statusConfig = getPromotionStatusConfig(promotion.status);

    const rows: Array<PublicationPreviewRowType> = [
        {
            key: 'status',
            label: <Locale stringKey="POSTS__TABLE__STATUS" />,
            value: <Badge color={statusConfig.badgeColor} text={getLocalizedString(statusConfig.langKey)} />,
        },
        ...(promotion.startAt
            ? [
                  {
                      key: 'startAt',
                      label: <Locale stringKey="PROMOTIONS__FORM__START_AT" />,
                      value: <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(promotion.startAt)} />,
                  },
              ]
            : []),
        ...(promotion.finishAt
            ? [
                  {
                      key: 'finishAt',
                      label: <Locale stringKey="PROMOTIONS__FORM__FINISH_AT" />,
                      value: <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(promotion.finishAt)} />,
                  },
              ]
            : []),
        ...(promotion.publishAt
            ? [
                  {
                      key: 'publishAt',
                      label: <Locale stringKey="PROMOTIONS__FORM__PUBLISH_AT" />,
                      value: <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(promotion.publishAt)} />,
                  },
              ]
            : []),
    ];

    return (
        <PublicationPreviewInfo
            createdAt={promotion.createdAt}
            footer={
                promotion.description ? (
                    <div style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                        <Text block secondary stringKey="PROMOTIONS__PREVIEW__DESCRIPTION" />
                        <Text block>{promotion.description}</Text>
                    </div>
                ) : null
            }
            onClose={onClose}
            rows={rows}
            thumbnailUrl={promotion.images[0]?.url}
            title={promotion.title}
        />
    );
}
